import { gsap } from 'gsap';

export default {
	name: 'default',
	leave({ current, next, trigger }) {
		return new Promise((resolve) => {
			document.dispatchEvent(new CustomEvent('transition-start'));

			gsap.to(current.container, {
				opacity: 0,
				ease: 'none',
				duration: 0.3,
				onComplete: () => {
					resolve();
				},
			});
		});
	},

	afterLeave({ current, next, trigger }) {
		return new Promise((resolve) => {
			gsap.set(current.container, {
				position: 'absolute',
			});

			gsap.set(next.container, {
				opacity: 0,
			});

			const color_m = next.container.dataset.colorM;
			const background_m = next.container.dataset.backgroundM;

			const color_d = next.container.dataset.colorD;
			const background_d = next.container.dataset.backgroundD;

			gsap.to(document.documentElement, {
				'--color-m': color_m,
				'--background-m': background_m,
				'--color-d': color_d,
				'--background-d': background_d,
				duration: 0.3,
				ease: 'none',
				overwrite: true,
				onComplete: () => {
					resolve();
				},
			});
		});
	},

	after({ current, next, trigger }) {
		return new Promise((resolve) => {
			document.dispatchEvent(new CustomEvent('transition-end'));

			gsap.to(next.container, {
				opacity: 1,
				ease: 'none',
				duration: 0.5,
				onComplete: () => {
					resolve();
				},
			});
		});
	},
};
